// Uebung.js
// Funktrainer M04 — Kernlogik
// Hier steht kein Inhalt, nur Mechanik. Inhalt liegt in daten.js.


// ─── Hilfsfunktion: zufaelliger Eintrag aus einer Liste ───────
// Nicht exportiert, weil sie nur hier drin gebraucht wird.

function zufall(liste) {
  return liste[Math.floor(Math.random() * liste.length)]
}


// ─── rendere: Loecher in einer Vorlage fuellen ────────────────
//
//   rendere('von {absender.rufname}', bindung)  ->  'von Fuchs 2'
//
// vorlage: Text mit {platzhaltern}
// bindung: Objekt mit den Werten, siehe binde()
// zurueck: fertiger Text

export function rendere(vorlage, bindung) {
  return vorlage.replace(/\{([^}]+)\}/g, (treffer, pfad) => {
    const teile = pfad.split('.')
    let wert = bindung
    for (const t of teile) {
      if (wert === undefined) break
      wert = wert[t]
    }
    if (wert === undefined) {
      throw new Error('Platzhalter nicht aufloesbar: {' + pfad + '}')
    }
    return wert
  })
}


// ─── binde: Werte wuerfeln ────────────────────────────────────
//
// Geht die Rollen des Schemas durch und wuerfelt fuer jede einen
// Eintrag aus dem passenden Inventar.
//
// zurueck: { absender: {...}, empfaenger: {...}, meldung: {...} }
//
// Achtung: Die Reihenfolge in schema.rollen zaehlt. Eine Rolle mit
// "nichtGleich" muss nach der Rolle stehen, auf die sie sich bezieht.
// "nichtGleich" ist ein Rollenname oder eine Liste davon:
//   nichtGleich: 'absender'
//   nichtGleich: ['absender', 'empfaenger1']
//
// Zwei weitere Einschraenkungen, damit ein Spruch Sinn ergibt:
//   wo:  { org: 'zivilschutz' }  nur Eintraege mit diesen Feldwerten
//   aus: 'meldung.von'           nur Eintraege, deren id in dieser Liste
//                                einer schon gewuerfelten Rolle steht
// Fuer "aus" gilt dieselbe Reihenfolge wie fuer "nichtGleich".

export function binde(schema, inventar) {
  const b = {}

  for (const rolle of schema.rollen) {
    let moegliche = inventar[rolle.typ]

    if (!moegliche) {
      throw new Error('Kein Inventar fuer Typ: ' + rolle.typ)
    }

    if (rolle.wo) {
      moegliche = moegliche.filter(x =>
        Object.entries(rolle.wo).every(([feld, wert]) => x[feld] === wert))
    }

    if (rolle.aus) {
      const [name, feld] = rolle.aus.split('.')
      if (!b[name]) {
        throw new Error(
          'Rolle "' + rolle.name + '" bezieht sich auf "' + name +
          '", die noch nicht gewuerfelt wurde. Reihenfolge in schema.rollen pruefen.'
        )
      }
      const ids = b[name][feld] || []
      moegliche = moegliche.filter(x => ids.includes(x.id))
    }

    for (const name of [].concat(rolle.nichtGleich || [])) {
      const andere = b[name]
      if (!andere) {
        throw new Error(
          'Rolle "' + rolle.name + '" bezieht sich auf "' + name +
          '", die noch nicht gewuerfelt wurde. Reihenfolge in schema.rollen pruefen.'
        )
      }
      moegliche = moegliche.filter(x => x.id !== andere.id)
    }

    if (moegliche.length === 0) {
      throw new Error('Keine Auswahl mehr fuer Rolle: ' + rolle.name)
    }

    b[rolle.name] = zufall(moegliche)
  }

  return b
}


// ─── baueUebung: Schema + Inventar -> fertige Uebung ──────────
//
// zurueck: {
//   kontext: 'Du bist Fuchs 2 am Standort Posten Nord.',
//   kategorie: 'grundschema',
//   zuege: [                                     // in RICHTIGER Reihenfolge
//     { nr, spricht, station,                    // station = gewuerfelter Eintrag
//       teile: [ { id, pos, rolle, text, regel, gleichwertig? }, ... ], // in RICHTIGER Reihenfolge
//       ablenker: [ { id, rolle, text, regel, ersetzt }, ... ] // gehoeren nicht hinein
//     }, ...
//   ]
// }
//
// binde() wird genau einmal aufgerufen. Sonst wuerden Kontext und
// Bausteine verschiedene Stationen nennen.
//
// Ablenker werden immer gebaut; ob sie in den Vorrat kommen, entscheidet
// die Ansicht. Sie haben kein "pos" — es gibt keinen richtigen Platz fuer
// sie. Die ids tragen die Zugnummer ('z0t1', 'z0a0'), damit sie in der
// ganzen Uebung eindeutig sind, nicht nur im Zug.
//
// Ein Slot darf mehrere gleichwertige Texte haben (text: ['richtig',
// 'verstanden'] — je nach ZSO ist beides richtig). Dann wird einer
// gewuerfelt, und die Uebung hat wieder genau eine Loesung. Alle Fassungen
// bleiben am Baustein ("gleichwertig"), fuer Ansichten, die frei bauen
// lassen und jede gelten lassen muessen.

export function baueUebung(schema, inventar) {
  const b = binde(schema, inventar)

  for (const zug of schema.zuege) {
    if (!b[zug.spricht]) {
      throw new Error('Zug spricht als "' + zug.spricht + '", diese Rolle gibt es nicht in schema.rollen.')
    }
  }

  const zuege = schema.zuege.map((zug, z) => ({
    nr: z,
    spricht: zug.spricht,
    station: b[zug.spricht],

    teile: zug.slots.map((slot, i) => {
      const fassungen = [].concat(slot.text).map(t => rendere(t, b))
      return {
        id: 'z' + z + 't' + i,
        pos: i,
        rolle: slot.rolle,
        text: zufall(fassungen),
        regel: slot.regel,
        ...(fassungen.length > 1 && { gleichwertig: fassungen })
      }
    }),

    ablenker: (zug.ablenker || []).map((a, i) => ({
      id: 'z' + z + 'a' + i,
      rolle: 'ablenker',
      text: rendere(a.text, b),
      regel: a.regel,
      ersetzt: a.ersetzt || null
    }))
  }))

  return {
    kategorie: schema.kategorie,
    kontext: rendere(schema.kontext, b),
    bindung: b,
    zuege
  }
}


// ─── wechseltAb: sprechen die Stationen immer abwechselnd? ────
//
// Mehr als ein Zug, und die rufende Station spricht auf jedem geraden
// Platz, eine andere auf jedem ungeraden. "Einfach sortieren" legt die
// Zuege links/rechts nach ihrem Platz und geht nur mit solchen Ablaeufen.
// Ein Ablauf wie "keine Antwort" (zweimal hintereinander gerufen) faellt
// damit von selbst heraus.

export function wechseltAb(schema) {
  const rufer = schema.zuege[0].spricht
  return schema.zuege.length > 1 &&
    schema.zuege.every((zug, i) => (zug.spricht === rufer) === (i % 2 === 0))
}


// ─── mische: Reihenfolge zerstoeren ───────────────────────────
//
// Gibt eine NEUE Liste zurueck. Das Original bleibt unveraendert —
// es ist die Loesung und wird noch gebraucht.

export function mische(liste) {
  const kopie = [...liste]
  for (let i = kopie.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[kopie[i], kopie[j]] = [kopie[j], kopie[i]]
  }
  return kopie
}


// ─── pruefe: liegt alles richtig? ─────────────────────────────
//
// Prueft EINEN Zug. Ein Ablauf mit mehreren Zuegen wird Zug fuer Zug
// geprueft.
//
// ablage: die Liste, die der Lernende fuer diesen Zug gelegt hat
// zug:    ein Eintrag aus baueUebung().zuege
//
// zurueck: {
//   bausteine: [ { text, status, hinweis }, ... ],  // status: korrekt | verschoben | fremd
//   vollstaendig: true/false,
//   sitzt: true/false
// }

// Wie entschieden wird, was "verschoben" ist:
//
// 1. Ablenker zaehlen fuer die Reihenfolge nicht mit. Sie werden mit ihrer
//    eigenen Regel gemeldet.
// 2. Jeder gelegte echte Baustein bekommt seinen Soll-Platz in der Loesung.
//    Verglichen wird der TEXT, nicht die id: kommt derselbe Text zweimal vor
//    (die einseitige Uebermittlung wiederholt die ganze Meldung), sind die
//    beiden Bausteine austauschbar. Der erste gelegte bekommt den ersten
//    freien Platz mit diesem Text.
// 3. Die laengste Folge von Bausteinen, deren Soll-Plaetze aufsteigen, liegt
//    zueinander richtig. Nur die uebrigen sind verschoben.
//
// Frueher wurde Platz fuer Platz verglichen. Dann machte EIN falscher
// Baustein alle dahinter "verschoben", und die Rueckmeldung nannte Regeln,
// die gar nicht verletzt waren — z.B. "Das Schlusswort steht am Ende" fuer
// ein "antworten", das am Ende stand.
//
// Der Hinweis zu einem verschobenen Baustein ist die "regel" seines Slots.

export function pruefe(ablage, zug) {
  const echte = ablage.filter(b => b.rolle !== 'ablenker')

  const frei = zug.teile.map(() => true)
  const sollPlatz = echte.map(b => {
    const i = zug.teile.findIndex((t, k) => frei[k] && t.text === b.text)
    frei[i] = false
    return i
  })
  const zueinanderRichtig = laengsteAufsteigende(sollPlatz)

  const bausteine = ablage.map(b => {
    if (b.rolle === 'ablenker') {
      return { id: b.id, text: b.text, status: 'fremd', hinweis: b.regel || null }
    }
    const korrekt = zueinanderRichtig.has(echte.indexOf(b))
    return {
      id: b.id,
      text: b.text,
      status: korrekt ? 'korrekt' : 'verschoben',
      hinweis: korrekt ? null : (b.regel || null)
    }
  })

  const fehlend = zug.teile.filter(
    t => !ablage.some(a => a.id === t.id)
  )

  const vollstaendig = fehlend.length === 0
  const sitzt = vollstaendig && bausteine.every(x => x.status === 'korrekt')

  return { bausteine, fehlend, vollstaendig, sitzt }
}


// ─── laengsteAufsteigende: wer liegt zueinander richtig? ──────
//
//   laengsteAufsteigende([1, 0, 2, 3])  ->  Set {0, 2, 3}
//
// werte:   die Soll-Plaetze in der gelegten Reihenfolge
// zurueck: die Positionen (in "werte") der laengsten Teilfolge, deren
//          Werte aufsteigen. Gibt es mehrere gleich lange, gewinnt die,
//          die frueher anfaengt.
// Nicht exportiert. Ein Zug hat nie mehr als ein Dutzend Bausteine, darum
// reicht der einfache Weg mit zwei Schleifen.

function laengsteAufsteigende(werte) {
  const laenge = werte.map(() => 1)
  const vorher = werte.map(() => -1)

  for (let i = 0; i < werte.length; i++) {
    for (let j = 0; j < i; j++) {
      if (werte[j] < werte[i] && laenge[j] + 1 > laenge[i]) {
        laenge[i] = laenge[j] + 1
        vorher[i] = j
      }
    }
  }

  const ergebnis = new Set()
  let i = laenge.indexOf(Math.max(0, ...laenge))
  while (i !== -1) {
    ergebnis.add(i)
    i = vorher[i]
  }
  return ergebnis
}
